import { createSlice } from '@reduxjs/toolkit'

import { runsheetShiftsAdapter } from '../adapters/runsheetShiftsAdapter'

export const initialRunsheetShiftState = runsheetShiftsAdapter.getInitialState()

export const runsheetShiftsSlice = createSlice({
  name: 'runsheetShifts',
  initialState: initialRunsheetShiftState,
  reducers: {
    upsertMultipleRunsheetShifts: (state, action) => {
      runsheetShiftsAdapter.upsertMany(state, action.payload)
    },
    removeMultipleRunsheetShifts: (state, action) => {
      runsheetShiftsAdapter.removeMany(state, action.payload)
    },
    replaceAllRunsheetShifts: (state, action) => {
      runsheetShiftsAdapter.setAll(state, action.payload)
    },
    removeRunsheetShift: (state, action) => {
      runsheetShiftsAdapter.removeOne(state, action.payload.id)
    },
  },
})

export const {
  upsertMultipleRunsheetShifts,
  removeMultipleRunsheetShifts,
  replaceAllRunsheetShifts,
  removeRunsheetShift,
} = runsheetShiftsSlice.actions